import * as THREE from 'three'

function getWrappedLines(ctx, text, maxWidth)
{
    const words = text.toUpperCase().split(' ')
    const lines = []
    let line = ''

    for(const word of words)
    {
        const testLine = line ? `${line} ${word}` : word

        if(ctx.measureText(testLine).width > maxWidth && line)
        {
            lines.push(line)
            line = word
        }
        else
        {
            line = testLine
        }
    }

    if(line)
    {
        lines.push(line)
    }

    return lines
}

function drawFittedText(ctx, text, centerX, startY, maxWidth, { maxLines = 3, startSize = 96, minSize = 44, lineHeightRatio = 1.12 } = {})
{
    let fontSize = startSize
    let lines = []

    while(fontSize >= minSize)
    {
        ctx.font = `700 ${fontSize}px "Comic Neue", Arial, sans-serif`
        lines = getWrappedLines(ctx, text, maxWidth)

        if(lines.length <= maxLines)
        {
            break
        }

        fontSize -= 6
    }

    const lineHeight = fontSize * lineHeightRatio
    let y = startY

    for(const entry of lines)
    {
        ctx.fillText(entry, centerX, y)
        y += lineHeight
    }

    return {
        fontSize,
        lineCount: lines.length,
        endY: y,
    }
}

export function createCompanyBillboardTexture({ company, title = '', period = '' })
{
    const canvas = document.createElement('canvas')
    canvas.width = 1024
    canvas.height = 1024
    const ctx = canvas.getContext('2d')
    const centerX = canvas.width / 2
    const maxWidth = 860

    ctx.fillStyle = '#f5f0e8'
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    ctx.fillStyle = '#4a3728'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'top'

    const companyLayout = drawFittedText(ctx, company, centerX, 250, maxWidth, {
        maxLines: 3,
        startSize: company.length > 24 ? 72 : 96,
        minSize: 44,
    })

    let contentY = companyLayout.endY + 36

    if(title)
    {
        ctx.font = '700 52px "Comic Neue", Arial, sans-serif'
        const titleLines = getWrappedLines(ctx, title, maxWidth)

        for(const entry of titleLines.slice(0, 2))
        {
            ctx.fillText(entry, centerX, contentY)
            contentY += 58
        }
    }

    if(period)
    {
        ctx.font = '700 40px "Comic Neue", Arial, sans-serif'
        ctx.fillText(period, centerX, contentY)
    }

    const texture = new THREE.CanvasTexture(canvas)
    texture.magFilter = THREE.NearestFilter
    texture.minFilter = THREE.LinearFilter
    texture.needsUpdate = true

    // #region agent log
    if(company.length > 20)
    {
        fetch('http://127.0.0.1:7823/ingest/d35b8971-5abb-4ced-aa93-3de090899b87',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'0ad91f'},body:JSON.stringify({sessionId:'0ad91f',runId:'billboard-text-fit',location:'createBillboardTexture.js',message:'long company name fitted',data:{company,fontSize:companyLayout.fontSize,lineCount:companyLayout.lineCount},timestamp:Date.now(),hypothesisId:'I'})}).catch(()=>{});
    }
    // #endregion

    return texture
}
